import React, { useState } from "react";
import Popupz from "../../atoms/Popupz";
import Inputz from "../../atoms/Inputz";
import Buttonz from "../../atoms/Buttonz";
import { requestPasswordReset } from "../../../auth/authApi";
import { pocketBaseErrorMessage } from "../../../auth/errors";
import { validateForgotEmail } from "../../../auth/validation";
import { useDispatch } from "react-redux";
import { validationPopup } from "../../../redux/actions";
import { BACKEND_URL } from "../../../config";

function normalizeEmailInput(value) {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  return trimmed ? trimmed.toLowerCase() : "";
}

async function checkEmailRegistered(email) {
  const e = normalizeEmailInput(email);
  if (!e) return false;

  const base = typeof BACKEND_URL === "string" ? BACKEND_URL : "";
  const res = await fetch(`${base}/email-availability`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: e }),
  });

  const json = await res.json().catch(() => null);
  if (!res.ok || !json?.ok) return false;
  return Boolean(json.used);
}

function ForgotPasswordPopup({ onClose, onSuccess }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    if (loading) return;
    const { errors: vErr } = validateForgotEmail(email);
    if (Object.keys(vErr).length > 0) {
      dispatch(
        validationPopup({
          message: vErr.email || "Email is required.",
          icon: "horror",
          type: "error",
        })
      );
      setError(true);
      return;
    }

    setLoading(true);
    dispatch(
      validationPopup({
        message: "Loading...",
        icon: "loading_ani",
      })
    );

    try {
      const exists = await checkEmailRegistered(email.trim());
      if (!exists) {
        dispatch(
          validationPopup({
            message: "No account is registered with this email address.",
            icon: "horror",
            type: "error",
          })
        );
        setError(true);
        return;
      }

      await requestPasswordReset(email.trim());
      dispatch(
        validationPopup({
          message: "Reset password email sent successfully",
          icon: "like",
          type: "success",
        })
      );
      onSuccess && onSuccess();
    } catch (err) {
      console.error("Forgot password API error:", err);
      dispatch(
        validationPopup({
          message: pocketBaseErrorMessage(err),
          icon: "horror",
          type: "error",
        })
      );
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Popupz
      title="Password Reset"
      text={
        <>
          Enter your email address and we'll send you instructions to reset your
          password.
        </>
      }
      onClose={onClose}
      popupId="login"
    >
      <div className="form-box">
        <Inputz
          iconL="mail"
          focusL="mail"
          label="Email"
          type="text"
          name="email"
          placeholder="Email"
          value={email}
          onChange={(e) => {
            setEmail(e.value);
            setError(false);
          }}
          error={error}
        />

        <Buttonz
          iconR="send"
          // hoverR="login"
          label="Send Reset Link"
          onClick={handleSubmit}
        />
        <div>
          Already member?{" "}
          <a
            onClick={() => {
              onClose();
              dispatch({ type: "SHOW_POPUP", payload: "login" });
            }}
          >
            Login
          </a>
        </div>
      </div>
    </Popupz>
  );
}

export default ForgotPasswordPopup;
